<template>
  
  <v-layout class="ma-0">
    <h3 class="mt-1">{{title}}</h3>
    <v-layout align-content-end justify-end class="ma-0">
      <v-btn small flat icon color="grey lighten-1" class="ma-0" @click="deleteForm()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
  </v-layout>

</template>

<script>
// @ is an alias to /src
export default {
  name: "BoxHeader",
  components: {
  },
  props: {
    title: String,
    questionObj : Object
  },
  data: () => ({}),
  computed: {
  },
  created: function(){},
  methods: {
    
    deleteForm() {
      // Delete from Vuex      
      this.$store.dispatch('deleteForm', this.questionObj.qid)
      // destroy the vue listeners, etc
      this.$destroy();
      // remove the element from the DOM
      // this.$el.parentNode.parentNode.removeChild(this.$el);
    }

  }
};
</script>

<style scoped>

</style>